/* ================================
   Custom Inova Script Layer for Flora
   ================================ */

document.addEventListener('DOMContentLoaded', function () {
  initInovaReveal();
  initInovaHeaderScroll();
  initInovaScrollProduct();
});

/* Scroll reveal animations */
function initInovaReveal() {
  const revealItems = document.querySelectorAll('[data-inova-reveal]');

  if (!revealItems.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15
    }
  );

  revealItems.forEach(function (item) {
    observer.observe(item);
  });
}

/* Sticky header scroll effect */
function initInovaHeaderScroll() {
  const header =
    document.querySelector('.site-header') ||
    document.querySelector('.header') ||
    document.querySelector('.shopify-section-header') ||
    document.querySelector('[data-section-type="header"]') ||
    document.querySelector('header');

  if (!header) return;

  header.classList.add('inova-header-active');

  function updateHeader() {
    if (window.scrollY > 20) {
      header.classList.add('inova-header-scrolled');
    } else {
      header.classList.remove('inova-header-scrolled');
    }
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}


/* Final Inova sofa reveal: bottom-slide animation */
function initInovaScrollProduct() {
  const sections = document.querySelectorAll('.inova-sofa-reveal');

  if (!sections.length) return;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function updateSection(section) {
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;
    const scrollable = rect.height - vh;

    if (scrollable <= 0) return;

    const progress = clamp(-rect.top / scrollable, 0, 1);

    /*
      Reference timing:
      0.00 - 0.12 = text visible, sofa barely visible
      0.12 - 0.48 = sofa slides up and covers text
      0.48 - 0.72 = sofa continues upward
      0.72 - 1.00 = section exits / next section appears
    */

    let sofaBottom;

    if (progress < 0.12) {
      sofaBottom = -38;
    } else if (progress < 0.48) {
      const p = easeOutCubic((progress - 0.12) / 0.36);
      sofaBottom = -38 + p * 48; // -38vh to 10vh
    } else if (progress < 0.72) {
      const p = easeOutCubic((progress - 0.48) / 0.24);
      sofaBottom = 10 + p * 38; // 10vh to 48vh
    } else {
      const p = easeOutCubic((progress - 0.72) / 0.28);
      sofaBottom = 48 + p * 14; // 48vh to 62vh
    }

    const buttonProgress = clamp((progress - 0.46) / 0.16, 0, 1);
    const buttonOpacity = buttonProgress;
    const buttonY = 20 - buttonProgress * 20;

    const media = section.querySelector('.inova-sofa-reveal__media');
    const button = section.querySelector('.inova-sofa-reveal__button');

    if (media) {
      media.style.setProperty('--sofa-bottom', sofaBottom + 'vh');
    }

    if (button) {
      button.style.setProperty('--button-opacity', buttonOpacity.toFixed(3));
      button.style.setProperty('--button-y', buttonY + 'px');
    }
  }

  function updateAll() {
    sections.forEach(updateSection);
  }

  updateAll();

  window.addEventListener('scroll', updateAll, { passive: true });
  window.addEventListener('resize', updateAll);
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;

    const items = entry.target.querySelectorAll(`
      h1,h2,h3,h4,h5,h6,
      p,
      img,
      .button,
      .btn,
      a.button,
      .card,
      .product-card,
      .collection-card,
      li,
      .grid > *,
      .slider__slide,
      .multicolumn-card,
      .banner__content > *,
      .rich-text__blocks > *,
      .image-with-text__content > *
    `);

    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add("reveal-active");
      }, index * 80);
    });

    observer.unobserve(entry.target);
  });
}, {
  threshold: 0.15
});

document.querySelectorAll(".shopify-section").forEach(section => {
  if (
    section.closest("header") ||
    section.classList.contains("header") ||
    section.classList.contains("site-header")
  ) {
    return;
  }

  observer.observe(section);
});